import { render, staticRenderFns } from "./TokevaRichText.vue?vue&type=template&id=76be7cc1&scoped=true"
import script from "./TokevaRichText.vue?vue&type=script&lang=js"
export * from "./TokevaRichText.vue?vue&type=script&lang=js"
import style0 from "./TokevaRichText.vue?vue&type=style&index=0&id=76be7cc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be7cc1",
  null
  
)

export default component.exports